import { I18N_NS } from "Config/i18n";
import { Form, Input } from "antd";
import { Trans, useTranslation } from "react-i18next";

interface FullTextSearchFieldsProps {
  initialData?: API_DocSearchReq;
}

export const FullTextSearchFields = ({ initialData }: FullTextSearchFieldsProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  return (
    <Form initialValues={initialData} layout="vertical" name="fullTextSearchFields">
      <Form.Item label={t("Full-text search")} name="docText">
        <Input />
      </Form.Item>
      <Trans ns={I18N_NS.PROJECT}>
        <p>
          Search within the documents for simple words or phrases (in quotation marks) or use boolean operators (AND,
          OR, NOT) to make the search query more precise. Wildcards (asterisk) are also allowed of course.
        </p>
        <p>Our AI-supported full-text search leads you quickly and purposefully to your result.</p>
      </Trans>
    </Form>
  );
};
